import React, { useState } from 'react';
import img1 from '../images/galleryImage/3.JPG';
import img2 from '../images/galleryImage/showimage1.webp';
import img3 from '../images/galleryImage/showimage2.webp';
import img4 from '../images/galleryImage/showimage3.webp';
import img5 from '../images/galleryImage/IMG_8482.JPG';
import img6 from '../images/galleryImage/IMG_5115.JPG';

import imgNan8 from "../images/galleryImage/1.webp";
import imgNan9 from "../images/galleryImage/2.webp";
import imgNan10 from "../images/galleryImage/3.webp";
import imgNan11 from "../images/galleryImage/4.webp";
import imgNan12 from "../images/galleryImage/5.webp";
import imgNan13 from "../images/galleryImage/6.webp";
import imgNan14 from "../images/galleryImage/7.webp";
import imgNan15 from "../images/galleryImage/8.webp";
import imgNan16 from "../images/galleryImage/10.webp";
import imgNan17 from "../images/galleryImage/11.webp";
import imgNan18 from "../images/galleryImage/14.webp";

const categories = ['All', 'Bridal', 'Arabic', 'Traditional', 'Festival'];

const works = [
    {
        id: 1,
        img: img2,
        title: 'Bridal Elegance',
        category: 'Bridal',
        desc: 'Intricate bridal patterns for the most special day'
    },

    
    {
        id: 2,
        img: img3,
        title: 'Arabic Fusion',
        category: 'Arabic',
        desc: 'Bold flowing Arabic designs with floral accents'
    },
    {
        id: 3,
        img: img4,
        title: 'Traditional Heritage',
        category: 'Traditional',
        desc: 'Classic traditional motifs passed through generations'
    },
    {
        id: 4,
        img: img5,
        title: 'Festival Special',
        category: 'Festival',
        desc: 'Vibrant festive designs for Eid & celebrations'
    },
    {
        id: 5,
        img: img6,
        title: 'Bridal Full Hands',
        category: 'Bridal',
        desc: 'Full hand coverage with stunning bridal artwork'
    },
    {
        id: 6,
        img: img1,
        title: 'Modern Arabic',
        category: 'Arabic',
        desc: 'Contemporary Arabic style with elegant detailing'
    },
];

function OurWorkComponent() {
    const [activeCategory, setActiveCategory] = useState('All');

    const filtered = activeCategory === 'All'
        ? works
        : works.filter(w => w.category === activeCategory);

    return (
        <section className="ourwork-section" id="OurWork">
            <div className="section-ornament">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>
            <div className="container">
                <div className="section-header text-center mb-4">
                    <span className="section-label">Portfolio</span>
                    <h2 className="section-title">Our Artistry</h2>
                    <p className="section-subtitle">Each design is a unique story told through the timeless art of henna</p>
                </div>

                <div className="work-filters d-flex justify-content-center flex-wrap gap-2 mb-5">
                    {categories.map(cat => (
                        <button
                            key={cat}
                            className={`work-filter-btn ${activeCategory === cat ? 'active' : ''}`}
                            onClick={() => setActiveCategory(cat)}
                        >
                            {cat}
                        </button>
                    ))}
                </div>

                <div className="works-grid">
                    {filtered.map(work => (
                        <div key={work.id} className="work-card">
                            <div className="work-img-wrap">
                                <img src={work.img} alt={work.title} />
                                <div className="work-overlay">
                                    <span className="work-category-tag">{work.category}</span>
                                    <h4 className="work-title">{work.title}</h4>
                                    <p className="work-desc">{work.desc}</p>
                                    <a href="/gallery" className="work-view-btn">View Gallery</a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-5">
                    <a href="/gallery" className="btn-mehandi-outline">
                        View Full Gallery
                    </a>
                </div>
            </div>
            <div className="section-ornament">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>
        </section>
    );
}

export default OurWorkComponent;
